import store from '@/store'


export default {

  /*
    Início
    permissões processo
  */
  ehUsuarioAdministrador() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "SADM") return true
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "ADM") return true
    return false
  },

    

  /*
    Início
    permissões processo
  */
  permitirAcaoExcluirDocumento() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "JURIDICO") return false
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirInserirDocumentoProcesso() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirSalvarProcesso() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirNotificacaoProcesso() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirAlterarPagamentoProcesso() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "SADM") return true
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "ADM") return true
    return false
  },

  /*
    Fim
    permissões processo
  */

  /*
    Início
    permissões cadastro cliente
  */
  permitirManutencaoEnderecoCliente() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirManutencaoTelefoneCliente() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirManutencaoEmailCliente() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirManutencaoCliente() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  },

  permitirManutencaoDocumentoCliente() {
    var usuario = store.getters['login/getUsuario']
    if (usuario.tp_usuario && usuario.tp_usuario.toUpperCase() == "USERCAP") return false
    return true
  }
  /*
    Fim
    permissões cadastro cliente
  */
}


// WEBPACK FOOTER //
// ./src/utils/privilegiosUsuario.js